import React from "react";
import { Camera, Clock } from "lucide-react";

const ProfileHeader = ({
  styles,
  theme,
  language,
  isRTL,
  screenSize,
  profilePicture,
  isUploading,
  employeeData,
  fileInputRef,
  triggerFileInput,
  handleFileSelect,
  handleMouseEnter,
  handleMouseLeave,
  t,
}) => {
  return (
    <div
      style={styles.profileHeader}
     
    >
      <div style={styles.profileHeaderContent}>
        {/* Avatar */}
        <div style={styles.profileAvatarLarge}>
          {profilePicture ? (
            <img
              src={profilePicture}
              alt="Profile"
              style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            employeeData.avatar
          )}
          <button
            className="nx-compact"
            style={{ ...styles.avatarEditBtn, opacity: isUploading ? 0.5 : 1 }}
            onClick={triggerFileInput}
            disabled={isUploading}
            title={isUploading ? t("uploading") : t("changePhoto")}
          >
            {isUploading
              ? <Clock size={screenSize.isMobile ? 12 : 14} />
              : <Camera size={screenSize.isMobile ? 12 : 14} />
            }
          </button>
        </div>

        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleFileSelect}
          style={{ display: "none" }}
        />

        {/* Info */}
        <div style={styles.profileInfo}>
          <h1 style={styles.profileName} title={employeeData.name}>{employeeData.name}</h1>
          <div style={styles.profileTitle}>{employeeData.position}</div>
          <div style={styles.profileDepartment} title={employeeData.email}>{employeeData.email}</div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;